OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PanelChooserDots = new Class({
    Implements: [Options, Events],
    element: null,
    bound_methods: {},
    options: {
        container_id: "header",
        dot_click_event: 'dot_click',
        number_of_dots: 1,
        panel_chooser_dots_id: "panel_dots",
        panel_chooser_dots_class: "panel_dot",
    },
    initialize: function (element, options) {
        this.setOptions(options);
        if (!element) {
            element = new Element('div', {id: this.options.panel_chooser_dots_id}).inject(document.id(this.options.container_id));

        }
        var chooser = element.retrieve('obj');
        if (chooser) {
            return chooser;
        }
        this.bound_methods.on_click = this.on_click.bind(this);
        this.element = element;
        this.draw();
        this.element.store('obj', this);
    },
    draw: function () {
        this.element.getChildren().each(function(el) {
            el.removeEvents();
            el.destroy();
        });
        var dot_el, i;
        for (i = 1; i <= this.options.number_of_dots; i++) {
            dot_el = new Element('span', {'data-panel_number': i});
            dot_el.addClass(this.options.panel_chooser_dots_class);
            dot_el.addClass(this.options.panel_chooser_dots_class+"_"+i);
            dot_el.inject(this.element);
            dot_el.addEvent('click', this.bound_methods.on_click);
        }
    },
    on_click: function(event) {
        this.fireEvent(this.options.dot_click_event, event);
    },
    set_number_of_dots: function (num) {
        this.options.number_of_dots = num;
        this.draw();
    },
    set_active_panel_number: function(active) {
        this.element.getChildren().each(function(dot) {
            if(dot.get('data-panel_number') == active) {
                dot.addClass('active');
            } else {
                dot.removeClass('active');
            }
        });

    },
    destroy: function() {
        this.element.getChildren().each(function(el) {
            el.removeEvents();
            el.destroy();
        });
        this.element.store('obj', null);
        this.element.destroy();
        this.removeEvents();
        this.element = null;
    }


});